/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@entrata/portals-common/lib/components/forms';
import { EmailField, PasswordField } from '@entrata/portals-common/lib/standard-fields';
import { removeError } from 'redux/modules/errors';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import { attemptLogin, setSuccessMessage, clearProcess } from 'redux/modules/user';
import { Link } from 'gatsby';
import { LoginBox } from 'components/account';
import { clearReferrers } from 'redux/modules/referrers';
import { navigate } from 'gatsby';
import { events, properties as daProperties } from 'api/digitalAnalytics';
import logAmplitudeEvent from 'utils/amplitude';

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.text.dark};
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  font-size: 13px;
  line-height: 15px;
`;

const StyledFormField = styled(Form.Field)`
  font-family: ${({ theme }) => theme.fonts.soehneBuch};

  label {
    color: ${({ theme }) => theme.text.dark};
    font-size: 14px;
  }
  input {
    color: ${({ theme }) => theme.text.dark};
    border-radius: 5px;
  }
`;
class Login extends Component {
  componentDidMount() {
    const { referrers, clearReferrers, setSuccessMessage, clearProcess } = this.props;
    if (referrers.includes('/forgot-password/')) {
      setSuccessMessage({ message: '' });
    }

    if (referrers.includes('/reset-password/')) {
      setTimeout(() => {
        setSuccessMessage({ message: '' });
      }, 5000);
    }
    clearReferrers();
    clearProcess();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.error && this.props.error) {
      this.setState({ loading: false });
    }
  }

  handleSubmit = ({ values: { email, password } }) => {
    const { removeError, location, attemptLogin } = this.props;
    const { LOG_IN_CLICK } = events;
    const { LOGIN_BUTTON } = daProperties;
    const eventProperties = [
      {
        name: LOGIN_BUTTON,
        value: 'User clicks on the Log in button',
      },
    ];
    let params = new URLSearchParams(location.search);
    const key = params.get('key');

    const returnUrl = typeof localStorage.returnUrl !== 'undefined' ? localStorage.returnUrl : '';
    let navigationUrl = '/app/policies/';

    if (returnUrl) {
      navigationUrl = returnUrl !== '/get-quote-v3/' ? returnUrl : navigationUrl;
      localStorage.removeItem(returnUrl);
    }

    this.setState({ loading: true });
    removeError('login');
    attemptLogin({
      userName: email,
      password: password,
      key: key,
      onComplete: () => navigate(navigationUrl),
    });

    //Amlitude Tracking
    logAmplitudeEvent(LOG_IN_CLICK, eventProperties);
  };

  initialFieldState = {
    email: { required: true },
    password: { required: true },
  };

  render() {
    const { error, location, successMessage, homebody2WebUrl } = this.props;

    // if (homebody2WebUrl) {
    //   navigate(`${homebody2WebUrl}/login`);
    //   return null;
    // }

    return (
      <LoginBox
        message={error}
        type='error'
        successMessage={successMessage}
        location={location}
        pageTitle='Log In'
        onSubmit={this.handleSubmit}
        initialFieldState={this.initialFieldState}
        btnText='Log in'
      >
        <StyledFormField name='email'>
          {(fieldProps) => <EmailField {...fieldProps} label='Email Address' />}
        </StyledFormField>
        <StyledFormField name='password'>
          {(fieldProps) => <PasswordField {...fieldProps} label='Password' />}
        </StyledFormField>
        <StyledLink to='/forgot-password/'>{__('Forgot Password?')}</StyledLink>{' '}
        {/* | <StyledLink to='/reset-password/'>{__('Reset Password')}</StyledLink> */}
      </LoginBox>
    );
  }
}

Login.propTypes = {
  location: PropTypes.object,
  error: PropTypes.string,
  successMessage: PropTypes.string,
  setSuccessMessage: PropTypes.func,
  attemptLogin: PropTypes.func,
  referrers: PropTypes.string,
  clearReferrers: PropTypes.func,
  removeError: PropTypes.func,
  attemptLogin: PropTypes.func.isRequired,
  error: PropTypes.string,
  clearProcess: PropTypes.func,
  homebody2WebUrl: PropTypes.string,
};

const ConnectedLogin = connect(
  ({ errors, user, referrers }) => ({
    error: errors.login || '',
    successMessage: user.successMessage || '',
    homebody2WebUrl: user.homebody2WebUrl,
    referrers: referrers,
  }),
  { attemptLogin, setSuccessMessage, clearReferrers, removeError, clearProcess },
)(Login);

export default ConnectedLogin;
